import { useState } from 'react';
import { mediaAdminApi } from '../lib/api';

/** Enregistrements et traductions : état, rétention, export, alertes. */
export function MediaAdminPage() {
  const [sessionId, setSessionId] = useState('');
  const [recordingId, setRecordingId] = useState('');
  const [trackId, setTrackId] = useState('');
  const [recordings, setRecordings] = useState<any[]>([]);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  async function run(fn: () => Promise<any>, note: string) {
    setError(''); setNotice(''); setResult(null);
    try { const r = await fn(); setResult(r); setNotice(note); }
    catch (e: any) { setError(String(e.message || e)); }
  }

  const ask = (l: string, d = '') => window.prompt(l, d) ?? '';

  return <section className="page">
    <header className="page-header">
      <div>
        <span className="eyebrow">MÉDIAS</span>
        <h1>Enregistrements et traductions</h1>
        <p>État du pipeline, durée de conservation, export et alertes de rétention.</p>
      </div>
    </header>

    {error && <div className="alert error">{error}</div>}
    {notice && <div className="notice">{notice}</div>}

    <div className="grid two">
      <div className="card">
        <h3>Enregistrements d'une séance</h3>
        <label>Séance<input value={sessionId} onChange={(e: any) => setSessionId(e.target.value)} placeholder="session_id" /></label>
        <div className="toolbar">
          <button className="button secondary" disabled={!sessionId.trim()} onClick={async () => {
            setError('');
            try { setRecordings(await mediaAdminApi.sessionRecordings(sessionId.trim())); }
            catch (e: any) { setError(String(e.message || e)); }
          }}>Lister</button>
          <button className="button primary" disabled={!sessionId.trim()} onClick={() => run(() => mediaAdminApi.startRecording(sessionId.trim()), 'Enregistrement démarré.')}>Démarrer</button>
        </div>
        {recordings.map(r => <div key={r.id} className="order-row">
          <strong>{r.id.slice(0, 8)}</strong>
          <span>{r.status}</span>
          <button className="button secondary" onClick={() => setRecordingId(r.id)}>Sélectionner</button>
        </div>)}
      </div>

      <div className="card">
        <h3>Actions sur un enregistrement</h3>
        <label>Enregistrement<input value={recordingId} onChange={(e: any) => setRecordingId(e.target.value)} placeholder="recording_id" /></label>
        <div className="toolbar">
          <button className="button secondary" disabled={!recordingId.trim()} onClick={() => run(() => mediaAdminApi.recording(recordingId.trim()), 'Détail chargé.')}>Détail</button>
          <button className="button secondary" disabled={!recordingId.trim()} onClick={() => {
            const status = ask('Nouvel état (PROCESSING, READY, FAILED)', 'READY');
            if (status) run(() => mediaAdminApi.setState(recordingId.trim(), status), 'État modifié.');
          }}>Changer l'état</button>
          <button className="button secondary" disabled={!recordingId.trim()} onClick={() => {
            const days = Number(ask('Conservation en jours', '90')); if (!days) return;
            run(() => mediaAdminApi.setRetention(recordingId.trim(), days), 'Rétention fixée.');
          }}>Rétention</button>
          <button className="button secondary" disabled={!recordingId.trim()} onClick={() => {
            const dest = ask('Destination de l\'export'); if (!dest) return;
            run(() => mediaAdminApi.exportRecording(recordingId.trim(), dest), 'Export demandé.');
          }}>Exporter</button>
        </div>
      </div>
    </div>

    <div className="grid two">
      <div className="card">
        <h3>Traductions</h3>
        <label>Piste<input value={trackId} onChange={(e: any) => setTrackId(e.target.value)} placeholder="track_id" /></label>
        <div className="toolbar">
          <button className="button secondary" disabled={!trackId.trim()} onClick={() => run(() => mediaAdminApi.translation(trackId.trim()), 'Piste chargée.')}>Détail</button>
          <button className="button secondary" disabled={!trackId.trim()} onClick={() => {
            const status = ask('État (PROCESSING, READY, FAILED)', 'READY');
            if (status) run(() => mediaAdminApi.setTranslationState(trackId.trim(), status), 'État modifié.');
          }}>Changer l'état</button>
        </div>
      </div>

      <div className="card">
        <h3>Alertes de rétention</h3>
        <p className="technical-note">Repère les enregistrements proches de leur date de suppression.</p>
        <button className="button primary" onClick={() => run(() => mediaAdminApi.retentionWarnings(), 'Alertes calculées.')}>Calculer les alertes</button>
      </div>
    </div>

    {result && <div className="card">
      <h3>Résultat</h3>
      <pre className="json-block">{JSON.stringify(result, null, 2).slice(0, 3000)}</pre>
    </div>}
  </section>;
}
